import * as types from "../actions/ActionTypes";

const defaultState = {
  lastVerification: undefined,
  newVersion: undefined,
  country: "",
  langs: [],
  screen: 'COMMUNITY_FILTER.HOME',
  showSidenav: false,
  showModal: false,
  showModalType: "",
  flixxValue: {}
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.APP_INFO_FULFILLED:
      let currentDate = new Date();
      return Object.assign({}, state, {
        lastVerification: currentDate,
        newVersion: action.payload,
        country: action.payload.country
      });
    case types.GET_LANGS:
      return {
        ...state,
        langs: action.payload,
      };
    case types.SET_SCREEN:
      return {
        ...state,
        screen: action.payload,
      };
    case types.TOGGLE_SIDENAV:
      return {
        ...state,
        showSidenav: !state.showSidenav
      }

    case types.OPEN_MODAL:
      return {
        ...state,
        showModal: true,
        showModalType: action.payload
      }
    case types.CLOSE_MODAL:
      return {
        ...state,
        showModal: false,
        showModalType: ""
      }
    case types.GET_FLIXX_INFO_FULFILLED:
      return {
        ...state,
        flixxValue: action.payload
      }
    default:
      return state;
  }
}
